import qs from 'qs'

export function querySerializer(query: Record<string, any> = {}) {
  try {
    return qs.stringify(query, {
      arrayFormat: 'brackets', // test[]=1&test[]=2
      encode: false, // 避免 %5B%5D；若後端要求可改 true
      skipNulls: true, // 避免 null 參數
    })
  } catch (error) {
    console.error('Error serializing query:', error)
    return ''
  }
}

/**
 * 解析價格字串或數字，移除千分位符號並轉換為數字
 * @param value - 價格值（可以是數字、字串、null 或 undefined）
 * @returns 解析後的數字，無效值返回 0
 */
export function parsePrice(value: number | string | null | undefined): number {
  if (value === null || value === undefined) return 0
  if (typeof value === 'string') {
    return Number(value.replace(/,/g, '')) || 0
  }
  return Number(value) || 0
}

/**
 * 判斷價格是否被降價（折扣價大於或等於原價時，視為無實質降價）
 * @param discount - FunNow 折扣價
 * @param rrp - 原價（Recommended Retail Price）
 * @returns 當兩個價格都有效且折扣價 < 原價時返回 true（有降價），否則返回 false
 */
export function isPriceReduced(discount: number | string | null | undefined, rrp: number | string | null | undefined): boolean {
  const discountPrice = parsePrice(discount)
  const originalPrice = parsePrice(rrp)
  // 當兩個價格都有效且折扣價小於原價時，才算有實質降價
  return discountPrice > 0 && originalPrice > 0 && discountPrice < originalPrice
}
